import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, Save } from 'lucide-react';
import { produits as produitsData, categoriesProduits } from '../../data/mockData';

function FormulaireProduit({ user }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditing = !!id;

  const [formData, setFormData] = useState({
    nom: '',
    categorieId: '',
    unite: 'L',
    seuilAlerte: 10,
    description: '',
    actif: true,
  });

  useEffect(() => {
    if (isEditing) {
      const produit = produitsData.find(p => p.id === parseInt(id));
      if (produit) {
        setFormData({
          nom: produit.nom,
          categorieId: produit.categorieId,
          unite: produit.unite,
          seuilAlerte: produit.seuilAlerte,
          description: produit.description || '',
          actif: produit.actif,
        });
      }
    }
  }, [id, isEditing]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : 
              (name === 'categorieId' || name === 'seuilAlerte') ? parseInt(value) : 
              value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Produit sauvegardé:', formData);
    navigate('/produits');
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <button onClick={() => navigate('/produits')} className="btn-back">
            <ArrowLeft size={20} />
            Retour
          </button>
          <h1>{isEditing ? 'Modifier le produit' : 'Nouveau produit'}</h1>
        </div>
      </div>

      <div className="form-container">
        <form onSubmit={handleSubmit} className="form-card">
          <div className="form-section">
            <h2>Informations du produit</h2>
            
            <div className="form-group">
              <label htmlFor="nom">Nom du produit *</label>
              <input
                type="text"
                id="nom"
                name="nom"
                value={formData.nom}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="categorieId">Catégorie *</label>
                <select
                  id="categorieId"
                  name="categorieId"
                  value={formData.categorieId}
                  onChange={handleChange}
                  required
                >
                  <option value="">Sélectionnez une catégorie</option>
                  {categoriesProduits.map(cat => (
                    <option key={cat.id} value={cat.id}>
                      {cat.nom}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="unite">Unité *</label>
                <select
                  id="unite"
                  name="unite"
                  value={formData.unite}
                  onChange={handleChange}
                  required
                >
                  <option value="L">Litre (L)</option>
                  <option value="pièce">Pièce</option>
                  <option value="boîte">Boîte</option>
                  <option value="kg">Kilogramme (kg)</option>
                </select>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="seuilAlerte">Seuil d'alerte *</label>
              <input
                type="number"
                id="seuilAlerte"
                name="seuilAlerte"
                value={formData.seuilAlerte}
                onChange={handleChange}
                min="0"
                required
              />
              <small>Un email sera envoyé lorsque le stock descend en dessous de ce seuil</small>
            </div>

            <div className="form-group">
              <label htmlFor="description">Description</label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                rows="3"
              />
            </div>
          </div>

          <div className="form-section">
            <div className="form-group-checkbox">
              <input
                type="checkbox"
                id="actif"
                name="actif"
                checked={formData.actif}
                onChange={handleChange}
              />
              <label htmlFor="actif">Produit actif</label>
            </div>
          </div>

          <div className="form-actions">
            <button type="button" onClick={() => navigate('/produits')} className="btn btn-secondary">
              Annuler
            </button>
            <button type="submit" className="btn btn-primary">
              <Save size={20} />
              Enregistrer
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default FormulaireProduit;

